import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import ActionLink from '../builder/ActionLink.js';
import EPPlatformVersion from '../builder/EPPlatformVersion';
import FloatingLayer from '../builder/FloatingLayer';
import SectionTitle from '../builder/SectionTitle';

const BooleanIcon = ({ value, ...props }) => {
	let classes = ['is_boolean'];
	classes.push((value) ? 'knk-on greenIcon' : 'knk-off redIcon');

	return (
		<span class={classes.join(" ")} />
	)
};

const AppsIncludedTable = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ display, setDisplay ] = useState(false);

	const min_basic = { basic:true, basicpro:true, premium:true, wl:true };
	const min_basic_pro = { basic:false, basicpro:true, premium:true, wl:true };
	const min_premium = { basic:false, basicpro:false, premium:true, wl:true };
	const min_wl = {basic:false, basicpro:false, premium:false, wl:true };

	const sections = [{
		label:"Giveaways",
		versions:min_basic,
		color:'8, 195, 168',
		data:[{
			label:"Entry Form Giveaway",
			icon:'knk-present',
			color:'#08C3A8',
		}, {
			label:"Instagram Giveaway",
			icon:'ep-instagram',
			color:'#D93175',
		}, {
			label:"Facebook Giveaway",
			icon:'ep-facebook',
			color:'#3B5998',
		}, {
			label:"List Giveaway",
			icon:'knk-ball-drum',
			color:'#9E9A2E',
		}, {
			label:"Event Giveaway",
			icon:'knk-live',
			color:'#4A4276',
		}, {
			label:"Twitter Giveaway",
			icon:'ep-twitter',
			color:'#55ACEE',
			versions:min_basic_pro,
		}, {
			label:"Multi-Network Giveaway",
			icon:'knk-diagram',
			versions:min_basic_pro,
		}, {
			label:"IG Stories Giveaway",
			icon:'knk-story',
			versions:min_basic_pro,
		}],
	}, {
		label:"Contests",
		versions:min_premium,
		color:'250, 165, 5',
		data:[{
			label:"Voting Contest",
			icon:'knk-like',
		}, {
			label:"Photo Contest",
			icon:'knk-photo-contest',
			enabled:false,
		}, {
			label:"Video Contest",
			icon:'knk-video-contest',
			enabled:false,
		}, {
			label:"Writing Contest",
			icon:'knk-write',
			enabled:false,
		}, {
			label:"PhotoFun",
			icon:'knk-sticker',
		}, {
			label:"Scenes",
			icon:'knk-frame',
		}, {
			label:"Mention + Hashtag",
			icon:'knk-hashtag',
		}, {
			label:"Hashtag + Entry Form",
			icon:'knk-instagram-contest',
		}, {
			label:"Pick Your Favorite",
			icon:'knk-like',
			enabled:false,
		}, {
			label:"Refer a Friend",
			icon:'knk-recruiter',
		}],
	}, {
		label:"Games",
		versions:min_premium,
		color:'65, 80, 185',
		data:[{
			label:"Puzzle",
			icon:'knk-puzzle',
		}, {
			label:"Memory",
			icon:'knk-memory',
		}, {
			label:"Tap Tap",
			icon:'knk-whac-a-mole',
		}, {
			label:"Match It",
			icon:'knk-match',
		}, {
			label:"Word Search",
			icon:'knk-wordsearch',
		}, {
			label:"Word Shuffle",
			icon:'knk-anagram',
		}, {
			label:"Slide & Match",
			icon:'knk-gem',
		}, {
			label:"The Tower",
			icon:'knk-stack-it',
		}, {
			label:"Hidden Objects",
			icon:'knk-search',
		}, {
			label:"Minesweeper",
			icon:'knk-bomb',
		}],
	}, {
		label:"Quizzes",
		versions:min_premium,
		color:'170, 30, 105',
		data:[{
			label:"Quiz with Timer",
			icon:'knk-timed-quiz',
		}, {
			label:"Knowledge Quiz",
			icon:'knk-brain',
		}, {
			label:"Product Recommender",
			icon:'knk-recommendator',
		}, {
			label:"Personality Quiz",
			icon:'knk-multichoice',
		}, {
			label:"Survey",
			icon:'knk-questions',
		}, {
			label:"Predictions",
			icon:'knk-prediction',
		}, {
			label:"Build your Team",
			icon:'knk-football-team-shirt',
		}],
	}, {
		label:"Instant prizes",
		versions:min_premium,
		color:'80, 175, 40',
		data:[{
			label:"Spin the Wheel",
			icon:'knk-roulette',
		}, {
			label:"Scratch & Win",
			icon:'knk-scratch',
		}, {
			label:"Reveal & Win",
			icon:'knk-chest',
		}, {
			label:"Instant Win",
			icon:'knk-winners',
		}, {
			label:"Distribute Coupon Codes",
			icon:'knk-promotional-code',
		}, {
			label:"Redeem Codes",
			icon:'knk-redeem-code',
		}, {
			label:"Receipt validation",
			icon:'knk-buy-ticket',
		}],
	}, {
		label:"Multi-Stage",
		versions:min_wl,
		color:'245, 110, 110',
		data:[{
			label:"Prize Calendar",
			icon:'knk-multi-calendar',
		}, {
			label:"Multi-Game",
			icon:'knk-multi-games',
		}, {
			label:"Digital Coupon Book",
			icon:'knk-multi-discount',
		}, {
			label:"Tournament Bracket",
			icon:'knk-multi-brackets',
		}, {
			label:"Multimedia Contest",
			icon:'knk-tiled-gallery',
			enabled:false,
		}, {
			label:"Multi-Round Predictions",
			icon:'knk-multi-match-predictions',
		}],
	}];

	const close = () => {
		setDisplay(false);
		if(props.close != undefined) props.close();
	};

	const total_columns = Object.keys(min_basic).length + 1;

	const col_styles = { width:'175px' };
	const header_row_styles = { height:'60px' };

	return (
		<>
			<ActionLink
				_class={props._class}
				onClick={() => setDisplay(true)}
			>{props?.label ?? "Which apps are included?"}</ActionLink>

			{(display) && (
				<FloatingLayer _class={{size:'big'}} backButton={close}>
					<div class="without_actions">
						<SectionTitle>Comparison Table: Applications included</SectionTitle>

						<table class="gui_props_table in_top">
							<thead>
								<tr>
									<th />

									<th style={col_styles}>
										<div class="gui_hidden_overflowed" style={header_row_styles}>
											<EPPlatformVersion version="basic" />
										</div>
									</th>

									<th style={col_styles}>
										<div class="gui_hidden_overflowed" style={header_row_styles}>
											<EPPlatformVersion version="basicpro" />
										</div>
									</th>

									<th style={col_styles}>
										<div class="gui_hidden_overflowed" style={header_row_styles}>
											<EPPlatformVersion version="premium" />
										</div>
									</th>

									<th style={col_styles}>
										<div class="gui_hidden_overflowed" style={header_row_styles}>
											<EPPlatformVersion version="wl" />
										</div>
									</th>
								</tr>
							</thead>

							{sections.map((section, s) => {
								const bg_color = section?.color ?? '--main-bg-color';

								return (
									<tbody key={s}>
										<tr class="section_header">
											<td colSpan={total_columns}>{i18n(section.label)}</td>
										</tr>

										{section.data.map((item, i) => {
											const enabled = item?.enabled ?? true;
											if(enabled === false) return null;

											const has_basic = item?.versions?.basic ?? (section?.versions?.basic ?? false);
											const has_basicpro = item?.versions?.basicpro ?? (section?.versions?.basicpro ?? false);
											const has_premium = item?.versions?.premium ?? (section?.versions?.premium ?? false);
											const has_wl = item?.versions?.wl ?? (section?.versions?.wl ?? false);

											const is_last = (i == section.data.length - 1) ? true : false;
											
											return (
												<tr key={i} class={(is_last) ? 'last_row' : null}>
													<td class="with_icon" style={{ backgroundColor:`rgba(${bg_color}, 0.2)`, borderColor:'rgba(0, 0, 0, 0.4)' }}>
														<span class={`icon ${item.icon}`} />{i18n(item.label)}
													</td>

													<td>
														{(typeof has_basic == 'boolean') ? (
															<BooleanIcon value={has_basic} />
														) : (
															<span>{has_basic}</span>
														)}
													</td>

													<td>
														{(typeof has_basicpro == 'boolean') ? (
															<BooleanIcon value={has_basicpro} />
														) : (
															<span>{has_basicpro}</span>
														)}
													</td>

													<td>
														{(typeof has_premium == 'boolean') ? (
															<BooleanIcon value={has_premium} />
														) : (
															<span>{has_premium}</span>
														)}
													</td>

													<td>
														{(typeof has_wl == 'boolean') ? (
															<BooleanIcon value={has_wl} />
														) : (
															<span>{has_wl}</span>
														)}
													</td>

												</tr>
											)
										})}
									</tbody>
								)
							})}
						</table>
					</div>
				</FloatingLayer>
			)}
		</>
	)
}

export default injectIntl(AppsIncludedTable);